import { WhatsAppTemplateStatus } from '@infobip/api'
import { Language } from '../../../translation/languages'
import { BrokerEnum } from '../../../partner-credential'

export const SPEND_LIMIT_TEMPLATE_BASE_KEY = 'syo_limite_gasto'

/**
 * Maiusculo porque `extractTagAndValueFromObject` normaliza toda chave de campo para maiusculo antes
 * de `toTemplateTextData` casar `###CHAVE`. Em minusculo a substituicao nao acontece e o alerta sai
 * com o percentual em branco.
 */
export const SPEND_LIMIT_TEMPLATE_VARIABLE_KEY = 'SPEND_LIMIT_PERCENTAGE'

/**
 * Valor default da variavel. So entra em cena se o disparo esquecer de informar o percentual — nesse
 * caso a mensagem sai com a palavra no lugar do numero, o que denuncia a falha em vez de parecer texto
 * cortado.
 */
export const SPEND_LIMIT_TEMPLATE_VARIABLE_DEFAULT_VALUE = 'limite'

export const SPEND_LIMIT_TEMPLATE_NOTIFICATION_TYPE = 'SPEND_LIMIT_ALERT'

export type NotificationType = typeof SPEND_LIMIT_TEMPLATE_NOTIFICATION_TYPE

export const SPEND_LIMIT_TEMPLATE_LABEL = 'Alerta de limite de mensagens livres'

export const SPEND_LIMIT_TEMPLATE_BODY =
    'Olá, informamos que este canal atingiu {{1}} do limite de mensagens livres que você definiu.'

export const SPEND_LIMIT_TEMPLATE_BODY_EXAMPLE = '90%'

export const SPEND_LIMIT_TEMPLATE_KEY_REGEX = /^(?:REMOVIDO-(?:INFOBIP|GUPSHUP)-)?syo_limite_gasto(?:_(\d+))?$/

export const isSpendLimitTemplateKey = (key?: string | null): boolean =>
    !!key && SPEND_LIMIT_TEMPLATE_KEY_REGEX.test(key)

export enum SpendLimitTemplateState {
    NOT_CREATED = 'NOT_CREATED',
    WAITING_APPROVAL = 'WAITING_APPROVAL',
    APPROVED = 'APPROVED',
    REJECTED = 'REJECTED',
    UNSUPPORTED_BROKER = 'UNSUPPORTED_BROKER'
}

export type SpendLimitTemplateBlockedReason =
    | 'BROKER_NOT_SUPPORTED'
    | 'ALREADY_PENDING'
    | 'ALREADY_APPROVED'
    | 'CREATION_IN_PROGRESS'

export type SpendLimitTemplateErrorCode =
    | 'BROKER_NOT_SUPPORTED'
    | 'ALREADY_EXISTS'
    | 'CREATION_IN_PROGRESS'
    | 'BROKER_RATE_LIMIT'
    | 'BROKER_ERROR'

export type SpendLimitTemplateRef = {
    id: string
    key: string
    metaStatus: WhatsAppTemplateStatus | null
    visible: boolean
    toReview: boolean
    removed: boolean
    errorMessage: string | null
    createdAt: string
    editedAt: string
}

export type SpendLimitTemplateStatusRequest = {
    group: string
    channel: string
    language: Language
    requestedBy: string
}

export type SpendLimitTemplateStatusResponse = {
    channel: string
    broker: BrokerEnum | null
    state: SpendLimitTemplateState
    canCreate: boolean
    blockedReason: SpendLimitTemplateBlockedReason | null
    nextKey: string
    reconciling: boolean
    lastCheckedAt: string | null
    template: SpendLimitTemplateRef | null
    history: SpendLimitTemplateRef[]
}

export type SpendLimitTemplateCreateRequest = {
    group: string
    channel: string
    language: Language
    createdBy: string
}

export type SpendLimitTemplateCreateResponse = {
    created: boolean
    key: string | null
    error: { code: SpendLimitTemplateErrorCode; message: string } | null
    status: SpendLimitTemplateStatusResponse
}
